// Central API origin for local development and production.
// Create React App loads .env.development for `npm start` and
// .env.production for `npm run build`.
const configuredBase = process.env.REACT_APP_API_BASE;

export const API_BASE = (
  configuredBase ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:4000"
    : "https://globizsystems.click")
).replace(/\/+$/, "");

export function apiUrl(path = "") {
  if (!path) return API_BASE;
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}
